import { PropsWithChildren, ReactNode } from "react";
import { AppHeader } from "components/AppHeader";

interface Props {
  title?: string | ReactNode;
  titleComponent?: string | ReactNode;
  left?: string | ReactNode;
}

export default function Header({
  title,
  titleComponent,
  left,
  children,
}: PropsWithChildren<Props>) {
  return (
    <AppHeader variant="classic" title={title} titleComponent={titleComponent} left={left}>
      {children}
    </AppHeader>
  );
}
